// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScannerTSD_container__hck2e {
  display: flex;
  justify-content: center;    /* по горизонтали центрируем */
  align-items: flex-start;    /* по вертикали выравниваем по верхнему краю */
  width: 100%;
  height: 100%;
  margin-bottom: 250px;
  top:50px;
  background-color: #f8f9fa;
}


.ScannerTSD_input__l1bZQ {
  width: 100%;
  max-width: 320px;
  font-size: 1.25rem; /* 20px */
  padding: 12px 16px;
  border: 2px solid #007bff; /* основной синий цвет */
  border-radius: 8px;
  outline: none;
  text-align: center;
  background-color: #fff;
  color: #212529;
  caret-color: #007bff;
  /* Убираем появление стандартной цифровой клавиатуры на мобильных */
  -webkit-text-security: disc;
}

.ScannerTSD_input__l1bZQ::placeholder {
  color: #6c757d;
  opacity: 1; /* чтобы цвет был ровным */
}

.ScannerTSD_input__l1bZQ:focus {
  border-color: #0056b3;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

/* Предотвращаем масштабирование при фокусе на iOS */
@supports (-webkit-touch-callout: none) {
  .ScannerTSD_input__l1bZQ:focus {
    font-size: 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/pages/Scanners/styles/ScannerTSD.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB,KAAK,8BAA8B;EAC1D,uBAAuB,KAAK,8CAA8C;EAC1E,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,QAAQ;EACR,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB;EAClB,yBAAyB,EAAE,wBAAwB;EACnD,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,mEAAmE;EACnE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,UAAU,EAAE,0BAA0B;AACxC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,oDAAoD;AACpD;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".container {\r\n  display: flex;\r\n  justify-content: center;    /* по горизонтали центрируем */\r\n  align-items: flex-start;    /* по вертикали выравниваем по верхнему краю */\r\n  width: 100%;\r\n  height: 100%;\r\n  margin-bottom: 250px;\r\n  top:50px;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n\r\n.input {\r\n  width: 100%;\r\n  max-width: 320px;\r\n  font-size: 1.25rem; /* 20px */\r\n  padding: 12px 16px;\r\n  border: 2px solid #007bff; /* основной синий цвет */\r\n  border-radius: 8px;\r\n  outline: none;\r\n  text-align: center;\r\n  background-color: #fff;\r\n  color: #212529;\r\n  caret-color: #007bff;\r\n  /* Убираем появление стандартной цифровой клавиатуры на мобильных */\r\n  -webkit-text-security: disc;\r\n}\r\n\r\n.input::placeholder {\r\n  color: #6c757d;\r\n  opacity: 1; /* чтобы цвет был ровным */\r\n}\r\n\r\n.input:focus {\r\n  border-color: #0056b3;\r\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\r\n}\r\n\r\n/* Предотвращаем масштабирование при фокусе на iOS */\r\n@supports (-webkit-touch-callout: none) {\r\n  .input:focus {\r\n    font-size: 1.25rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScannerTSD_container__hck2e`,
	"input": `ScannerTSD_input__l1bZQ`
};
export default ___CSS_LOADER_EXPORT___;
